import React from 'react';

const HomeConf2 = props => {

    return (
        <div></div>
    )
}

export default HomeConf2